<template>
  <div class="live">
    <section
      class="is-flex is-justify-content-space-between is-align-items-center"
    >
      <router-link to="/lobby">
        <a class="is-size-4 has-text-link">
          &lt;&lt; Lobby
        </a>
      </router-link>

      <div class="is-flex">
        <p class="is-size-4 has-text-success-dark mb-0 mr-3">
          {{ filteredMatches.length }} live matches
        </p>

        <DelayedInput
          style="width: 300px;"
          v-model="filterName"
          type="search"
          icon="search"
          placeholder="Type player name to search..."
        />
      </div>

      <div class="is-flex is-justify-content-space-between filter-checkboxes">
        <label class="checkbox is-danger">
          <input type="checkbox" v-model="showThreats" />
          Show threats
        </label>
        <label class="checkbox is-danger">
          <input type="checkbox" v-model="onlyPvP" />
          PvP Only
        </label>
      </div>
    </section>

    <section class="live__games">
      <div
        class="live__board p-2 mt-5 is-relative"
        v-for="id in shownIds"
        :key="id"
      >
        <b-checkbox-button
          v-model="pinnedIds"
          :native-value="id"
          type="is-info is-light"
          is-outlined
          class="live__board__pin"
        >
          <b-icon icon="thumbtack"></b-icon>
        </b-checkbox-button>
        <div @click="viewMatch(id)">
          <GameViewV2
            v-if="isPvAi(id)"
            :gameId="id"
            :viewThreats="showThreats"
          />
          <GameView v-else :gameId="id" :showThreats="showThreats" />
        </div>
      </div>
    </section>

    <button
      class="button mt-4"
      v-if="liveMatches.length > maxToShow && maxToShow < 10"
      @click="maxToShow = 12"
    >
      Show more
    </button>

    <div class="mt-6">
      <RoomSpectators roomId="live" :showSpectators="true" />
    </div>
  </div>
</template>

<script>
import GameView from "@/components/games/GameView";
import { GAME_OVERRIDE } from "vue-chess-shared/constants";
import DelayedInput from "@/components/DelayedInput";
import RoomSpectators from "@/components/rooms/RoomSpectators";
import { firestore } from "@/services/firebase";
import GameViewV2 from "@/components/games/GameViewV2";
import gameUrls from "@/mixins/gameUrls";
import { addDuration, isAfter } from "vue-chess-shared/utils/date-helper";

const matches = firestore.collection("matches");
const liveMatches = matches.where("status", "==", "live");

export default {
  components: {
    DelayedInput,
    RoomSpectators,
    GameView,
    GameViewV2,
  },

  name: "liveMatches",

  mixins: [gameUrls],

  title() {
    return "Live";
  },

  data() {
    return {
      liveMatches: [],
      showThreats: false,
      onlyPvP: false,
      filterName: "",
      maxToShow: 6,
      pinnedIds: [],
    };
  },

  firestore: {
    liveMatches: liveMatches,
  },

  computed: {
    unpinnedIds() {
      let unpinnedMatches = this.filteredMatches.filter(
        (match) => !this.pinnedIds.includes(match.id)
      );
      if (this.filterName) {
        unpinnedMatches = unpinnedMatches.filter(
          (match) =>
            (match.player1.name &&
              match.player1.name
                .toLowerCase()
                .includes(this.filterName.toLowerCase())) ||
            (match.player2.name &&
              match.player2.name
                .toLowerCase()
                .includes(this.filterName.toLowerCase()))
        );
      }
      const unpinnedCount = this.maxToShow - this.pinnedIds.length;
      return [...new Set(unpinnedMatches.map((match) => match.id))].slice(
        0,
        unpinnedCount
      );
    },

    shownIds() {
      return [...this.pinnedIds, ...this.unpinnedIds];
    },

    filteredMatches() {
      const showAll =
        this.$route.query.showAll || this.$route.query.showall || false;
      let filtered = this.onlyPvP
        ? this.liveMatches.filter(
            (m) =>
              m.gameOverride === GAME_OVERRIDE.PVP ||
              m.gameOverride === GAME_OVERRIDE.TOURNAMENT
          )
        : this.liveMatches;

      if (!showAll) {
        const twoHoursAgo = addDuration(new Date(), -2, "hour");
        filtered = filtered.filter((m) => {
          return isAfter(m.createdAt, twoHoursAgo);
        });
      }

      return filtered.slice().sort((a, b) => b.gameOverride - a.gameOverride);
    },
  },

  methods: {
    isPvAi(id) {
      const match = this.liveMatches.find((m) => m.id === id);
      return match.gameOverride === GAME_OVERRIDE.PVAI;
    },
    viewMatch(matchId) {
      console.log("viewMatch", matchId);
      this.$router.push({
        path: this.getGameUrl(matchId),
      });
    },
  },
};
</script>

<style scoped>
.live__games {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin-left: auto;
  margin-right: auto;
}

.live__board {
  border: 2px solid green;
  width: 360px;
}

.live__board__pin {
  position: absolute;
  top: 0;
  right: 50px;
  width: 40px;
  text-align: center;
  border: none;
}

.button .icon:first-child:not(:last-child) {
  margin: auto;
}

.b-checkbox > .button {
  border: none;
}

.filter-checkboxes {
  flex: 0.4;
}
</style>
